import { CurriedGetDefaultMiddleware } from '@reduxjs/toolkit/dist/getDefaultMiddleware'

import { combineReducers } from 'redux'

import { baseApi } from './api/baseApi'
import { RootState } from './store'


import alert from './ui/common/alertUI'
import academicPeriods from './ui/academicPeriodsUI'
import adjustments from './ui/adjustmentsUI'
import announcements from './ui/announcementsUI'
import assignments from './ui/assignmentsUI'
import attendance from './ui/attendanceUI'
import behavior from './ui/behaviorUI'
import benchmarks from './ui/benchmarksUI'
import benchmarkEvaluations from './ui/benchmarkEvaluationsUI'
import clusters from './ui/clustersUI'
import courses from './ui/coursesUI'
import courseChapters from './ui/courseChaptersUI'
import courseComponents from './ui/courseComponentsUI'
import curriculum from './ui/curriculumUI'
import dashboard from './ui/dashboardUI'
import domains from './ui/domainsUI'
import earlyWarnings from './ui/earlyWarningsUI'
import fluencies from './ui/fluenciesUI'
import goals from './ui/goalsUI'
import goalbank from './ui/goalbankUI'
import gradeRiskCriteria from './ui/gradeRiskCriteriaUI'
import groups from './ui/groupsUI'
import groupCourses from './ui/groupCoursesUI'
import groupCourseGradebook from './ui/groupCourseGradebookUI'
import gradeScale from './ui/gradeScaleUI'
import gradebookAssessments from './ui/gradebookAssessmentsUI'
import highlights from './ui/highlightsUI'
import kpiEvaluations from './ui/kpiEvaluationsUI'
import ledger from './ui/ledgerUI'
import lessonPlans from './ui/lessonPlansUI'
import medicalRecords from './ui/medicalRecordsUI'
import meetings from './ui/meetingsUI'
import milestones from './ui/milestonesUI'
import parents from './ui/parentsUI'
import plop from './ui/plopUI'
import practices from './ui/practicesUI'
import riskCriteria from './ui/school/riskCriteriaUI'
import rtiInterventions from './ui/rtiInterventionsUI'
import rtiRiskCriteria from './ui/rtiRiskCriteriaUI'
import rtiConcernReasons from './ui/rtiConcernReasonsUI'
import rubrics from './ui/rubricsUI'
import sessions from './ui/sessionsUI'
import sidebar from './ui/sidebarUI'
import skills from './ui/skillsUI'
import slo from './ui/sloUI'
import staff from './ui/staffUI'
import students from './ui/studentsUI'
import successCriteria from './ui/successCriteriaUI'
import syllabus from './ui/syllabusUI'
import submissions from './ui/submissionsUI'
import teachers from './ui/teachersUI'
import timetables from './ui/timetablesUI'
import teams from './ui/teamsUI'
import theme from './ui/common/themeUI'
import user from './ui/common/userUI'
import verbs from './ui/verbsUI'


export const combinedReducer = combineReducers({
  [baseApi.reducerPath]: baseApi.reducer,
  academicPeriods,
  adjustments,
  alert,
  announcements,
  assignments,
  attendance,
  behavior,
  benchmarks,
  benchmarkEvaluations,
  courses,
  courseChapters,
  courseComponents,
  curriculum,
  clusters,
  dashboard,
  domains,
  earlyWarnings,
  fluencies,
  goals,
  goalbank,
  groups,
  groupCourses,
  groupCourseGradebook,
  gradebookAssessments,
  gradeRiskCriteria,
  gradeScale,
  highlights,
  kpiEvaluations,
  ledger,
  lessonPlans,
  medicalRecords,
  meetings,
  milestones,
  sessions,
  sidebar,
  skills,
  slo,
  staff,
  students,
  successCriteria,
  submissions,
  syllabus,
  parents,
  plop,
  practices,
  riskCriteria,
  rtiInterventions,
  rtiRiskCriteria,
  rtiConcernReasons,
  rubrics,
  teachers,
  teams,
  theme,
  timetables,
  user,
  verbs
})

export const rootReducer = (state, action) => {
  if (action.type === 'RESET') {
    state = undefined
  }
  return combinedReducer(state, action)
}

export const rootMiddleware = (getDefaultMiddleware: CurriedGetDefaultMiddleware<RootState>) => {
  return getDefaultMiddleware().concat(baseApi.middleware)
}
